// @ts-nocheck — TODO: tipizzare (S6) — EventTarget.closest cast
// ====== F10: Hover preview cliente ======
// Tooltip ricco mostrato al hover prolungato (~400ms) su una riga cliente
// nelle tabelle/lista clienti. Mostra CPL/PM/perimetri/contratto/scadenza in
// 1 secondo senza dover aprire il modal.

const HOVER_DELAY = 400; // ms
let _hoverTimer = null;
let _previewEl = null;
let _currentTarget = null;

function ensurePreviewEl() {
  if (_previewEl) return _previewEl;
  _previewEl = document.createElement('div');
  _previewEl.className = 'cli-preview';
  _previewEl.setAttribute('role', 'tooltip');
  document.body.appendChild(_previewEl);
  return _previewEl;
}

function clientByName(name) {
  // @ts-ignore — state globale
  return (state?.clients || []).find((c) => c.nome === name) || null;
}

function previewHtml(c) {
  if (!c) return '';
  // @ts-ignore — daysUntil globale
  const fineG =
    c.contratto?.fine && typeof daysUntil === 'function' ? daysUntil(c.contratto.fine) : null;
  const nextScad = (c.scadenze || [])
    .filter((s) => !s.completata && s.data)
    .map((s) => ({
      ...s,
      // @ts-ignore
      g: typeof daysUntil === 'function' ? daysUntil(s.data) : null
    }))
    .filter((s) => s.g !== null)
    .sort((a, b) => a.g - b.g)[0];

  const attivi = Object.values(c.accessi || {}).filter(
    (v) => (v || '').toLowerCase().trim() === 'sì' || (v || '').toLowerCase().trim() === 'si'
  ).length;
  const daRich = Object.values(c.accessi || {}).filter((v) => v === 'Da richiedere').length;

  return `<h4>${escapeHtml(c.nome)}</h4>
    <div class="cli-preview-row"><span>CPL</span><span>${escapeHtml(c.cpl || '—')}</span></div>
    <div class="cli-preview-row"><span>PM1</span><span>${escapeHtml(c.pm1 || '—')}</span></div>
    ${c.pm2 ? `<div class="cli-preview-row"><span>PM2</span><span>${escapeHtml(c.pm2)}</span></div>` : ''}
    <div class="cli-preview-row"><span>Accessi attivi</span><span>${attivi}${daRich ? ` · ${daRich} da richiedere` : ''}</span></div>
    ${
      c.contratto?.fine
        ? `<div class="cli-preview-row"><span>Fine contratto</span><span>${escapeHtml(
            // @ts-ignore — fmtDate globale
            fmtDate(c.contratto.fine)
          )}${fineG !== null ? ` (${fineG < 0 ? `scaduto ${-fineG}gg fa` : `tra ${fineG}gg`})` : ''}</span></div>`
        : ''
    }
    ${
      nextScad
        ? `<div class="cli-preview-row"><span>Prossima scadenza</span><span>${escapeHtml(nextScad.titolo)}${nextScad.g !== null ? ` (${nextScad.g < 0 ? 'scaduta' : 'tra ' + nextScad.g + 'gg'})` : ''}</span></div>`
        : ''
    }
    ${
      (c.perimetri || []).length
        ? `<div class="cli-preview-perim">${c.perimetri
            // @ts-ignore — perimetroClass globale
            .map((p) => `<span class="perimeter-pill ${perimetroClass(p)}">${escapeHtml(p)}</span>`)
            .join('')}</div>`
        : ''
    }`;
}

function positionPreview(targetRect) {
  const el = _previewEl;
  if (!el) return;
  const margin = 8;
  const rect = el.getBoundingClientRect();
  let left = targetRect.right + margin;
  let top = targetRect.top;
  // Se esce a destra, mettilo a sinistra del target
  if (left + rect.width > window.innerWidth - 8) {
    left = targetRect.left - rect.width - margin;
  }
  // Se esce in basso, allinea in basso
  if (top + rect.height > window.innerHeight - 8) {
    top = window.innerHeight - rect.height - 8;
  }
  if (left < 8) left = 8;
  if (top < 8) top = 8;
  el.style.left = left + 'px';
  el.style.top = top + 'px';
}

function showPreviewFor(target) {
  const name = target.dataset.previewCliente || target.dataset.cliente;
  if (!name) return;
  const c = clientByName(name);
  if (!c) return;
  const el = ensurePreviewEl();
  el.innerHTML = previewHtml(c);
  const rect = target.getBoundingClientRect();
  positionPreview(rect);
  el.classList.add('open');
  _currentTarget = target;
}

function hidePreview() {
  if (_previewEl) _previewEl.classList.remove('open');
  _currentTarget = null;
}

document.addEventListener('mouseover', (e) => {
  const t = e.target?.closest?.('[data-preview-cliente], tr[data-cliente]');
  if (!t || t === _currentTarget) return;
  // Skip se il bersaglio è dentro un modal/popover
  if (t.closest('.modal, .qs-overlay, .cli-preview')) return;
  clearTimeout(_hoverTimer);
  _hoverTimer = setTimeout(() => showPreviewFor(t), HOVER_DELAY);
});

document.addEventListener('mouseout', (e) => {
  const t = e.target?.closest?.('[data-preview-cliente], tr[data-cliente]');
  if (!t) return;
  clearTimeout(_hoverTimer);
  hidePreview();
});

document.addEventListener(
  'scroll',
  () => {
    hidePreview();
  },
  true
);
window.addEventListener('blur', hidePreview);
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') hidePreview();
});

// @ts-ignore — global
Object.assign(globalThis, { showPreviewFor, hidePreview });
export {};
